import { Component, forceUpdate, h, Host, Listen, State } from '@stencil/core';

import wcShared from '@web-components/shared';

import userStore from '../../stores/store';

@Component({
  tag: 'module-menu-user',
  styleUrl: 'main-layout.scss',
  shadow: true,
})
export class MainLayout {
  @State() canBeDisplayed = true;
  @State() loading = false;
  @State() innerWidth: number;

  private panelRef: { visible: boolean; close: () => void; open: () => void };

  @Listen('closeEvent')
  closeEventHandler() {
    this.panelRef.close();
  }

  @Listen('scroll', { target: 'window' })
  handleScroll() {
    const scrollTop = document.documentElement.scrollTop;
    if (
      this.panelRef.visible &&
      this.innerWidth <= 500 &&
      scrollTop > 30 &&
      ['hosting2', 'hosting3'].includes(window['CURRENT_PROJECT'])
    ) {
      this.panelRef.close();
    }
  }

  componentWillLoad() {
    if (!window['WC_MODULES_COMMON'].includes('menu-user')) {
      this.canBeDisplayed = false;
      return null;
    }
    wcShared.displayComponent('menu-user');

    wcShared?.store?.addObserver('hideShow', (value: boolean) => {
      this.panelRef.visible = value;
    });

    this.innerWidth = window.innerWidth;
    window.addEventListener('resize', (event: Event) => {
      this.innerWidth = (event.target as Window).innerWidth;
    });
    wcShared.store.addObserver('theme', () => forceUpdate(this));
  }

  componentDidLoad() {
    document.dispatchEvent(new CustomEvent('WCDidLoad', { detail: 'menu-user' }));
  }

  private initAtClick() {
    if (!Boolean(userStore.groups)) {
      this.getMenuElements();
    }
  }

  private getMenuElements() {
    this.loading = true;

    return wcShared
      .httpCall('GET', '/api/components/profile/me?with=user,groups,product_renew')
      .then((r) => r.json())
      .then((response) => {
        const data = response?.data as IWCMe;

        userStore.currentGroup = data?.groups.find(
          (item) => item.id === data?.user?.current_account_id,
        );
        userStore.currentUser = data?.user;
        userStore.groups = data?.groups;
        userStore.renewsCount = data?.renews?.count + data?.invoices?.count;
        userStore.hasManyGroups = userStore.groups.length > 1;

        window['webComponentsStore'].userGroups = data?.groups;
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  render() {
    if (!this.canBeDisplayed) {
      return null;
    }

    return (
      <Host>
        <wc-panel
          ref={(ref) => (this.panelRef = ref)}
          class={`layout theme-${wcShared?.store?.theme}`}
          onOpen={() => {
            this.initAtClick();
          }}
        >
          <div
            aria-haspopup="true"
            aria-expanded="false"
            slot="trigger"
          >
            <slot name="trigger"></slot>
          </div>

          <menu-user
            class={`theme-${wcShared?.store?.theme}`}
            loading={this.loading}
            closeLayout={() => this.panelRef.close()}
          />
        </wc-panel>
      </Host>
    );
  }
}
